<h2 mat-dialog-title>
  {{ title | translate: { name: automation.name } }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <p *ngIf="automationIsDraining">{{ description | translate }}</p>
    <form [formGroup]="form" novalidate *ngIf="!automationIsDraining && !isBuiltIn">
      <glxy-form-field>
        <mat-radio-group [formControl]="runningStateControl">
          <mat-radio-button [value]="RunningState.RUNNING_STATE_STOPPED" tabindex="-1">
            {{ 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_OPTION' | translate }}
            <extended>{{ 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_OPTION_HINT' | translate }}</extended>
          </mat-radio-button>
          <mat-radio-button [value]="RunningState.RUNNING_STATE_DRAINING" tabindex="-1">
            {{ 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.DRAIN_OPTION' | translate }}
            <extended>{{ 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.DRAIN_OPTION_HINT' | translate }}</extended>
          </mat-radio-button>
        </mat-radio-group>
      </glxy-form-field>
    </form>
    <div class="alert-padding">
      <glxy-alert type="warning" *ngIf="automationIsDraining">
        <span [innerHTML]="'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_ALERT' | translate"></span>
      </glxy-alert>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close>{{ 'AUTOMATIONS.COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button mat-button color="warn" (click)="continue()">
    {{ action | translate }}
  </button>
</mat-dialog-actions>
